import { Box, Button, Link } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { sendTrackingEvent } from '../../../utils/gtm';

const ProgressFooter = ({
	currentStep,
	setCurrentStep,
	handleFormSubmit,
	handleSignUpVerifyOtp,
	showOtpUi,
	handleCollegeInfoSubmit,
	handleJobPreferenceSubmit,
	handleCourseEnrolremtSubmit,
	isLoading,
	disabled,
}: {
	currentStep: number;
	setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
	handleFormSubmit: () => void;
	handleSignUpVerifyOtp: () => void;
	showOtpUi: boolean;
	handleCollegeInfoSubmit: () => void;
	handleJobPreferenceSubmit: () => void;
	handleCourseEnrolremtSubmit: () => void;
	isLoading: boolean;
	disabled?: boolean;
}) => {
	return (
		<Box
			h="72px"
			mx="-16px"
			width={'100%'}
			px="16px"
			py="12px"
			boxShadow={{ base: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', md: 'none' }}
			position={{ base: 'fixed', md: 'relative' }}
			bottom={'0px'}
			bg="white"
			textAlign="center"
		>
			<Button
				onClick={() => {
					if (currentStep === 1 && !showOtpUi) {
						// handle send signup otp
						handleFormSubmit();
						sendTrackingEvent({
							event: 'cn_signup_continue',
							eventLabel: window.location.href,
						});
					} else if (currentStep === 1 && showOtpUi) {
						// handle verify otp
						handleSignUpVerifyOtp();
						sendTrackingEvent({
							event: 'cn_signup_verify',
							eventLabel: window.location.href,
						});
					} else if (currentStep === 2) {
						handleCollegeInfoSubmit();
						sendTrackingEvent({
							event: 'cn_onboarding_continue',
							eventLabel: window.location.href,
						});
					} else if (currentStep === 3) {
						handleJobPreferenceSubmit();
						sendTrackingEvent({
							event: 'cn_onboarding_continue1',
							eventLabel: window.location.href,
						});
					} else if (currentStep === 4) {
						handleCourseEnrolremtSubmit();
						sendTrackingEvent({
							event: 'cn_onboarding_continue2',
							eventLabel: window.location.href,
						});
					}
				}}
				variant={'primary'}
				width={'100%'}
				size={'lg'}
				maxW={{ md: '343px' }}
				mx="auto"
				bgColor={'#4358F6'}
				isDisabled={disabled}
				// backgroundColor={currentStep === 1 && !isSignUpChecked ? 'ms-blue.100' : '#4358F6'}
				isLoading={isLoading}
			>
				{showOtpUi ? 'Verify' : 'Continue'}
			</Button>
			{currentStep === 1 && !showOtpUi ? (
				<Box
					display={{ base: 'none', md: 'flex' }}
					gap="8px"
					color="#544D4F"
					textStyle="body1-md"
					justifyContent="center"
					textAlign="center"
					mt="30px"
					flexWrap="wrap"
				>
					Already have an account?
					<Link as={RouterLink} color="#386AFA" to="/sign-in">
						Sign In
					</Link>
				</Box>
			) : (
				<></>
			)}
		</Box>
	);
};

export default ProgressFooter;
